import { gql } from '../../__generated__/gql'

export const DEACTIVATE_LOGIN_SESSION_MUTATION = gql(`
  mutation deactivateLoginSession($id: Int!) {
    deactivateLoginSession(input: { id: $id }) {
      clientMutationId
    }
  }
`)
